// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M22.5 2V18H6.87574L1.5 22.7038V2H22.5ZM10.5854 14.6568L17.6565 7.58572L16.2423 6.17151L10.5854 11.8284L7.75699 8.99993L6.34277 10.4141L10.5854 14.6568Z"}}]};

const ChatCheckedFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'chat-checked-filled',
    ref,
    icon: element,
  },
));

ChatCheckedFilledIcon.displayName = 'ChatCheckedFilledIcon';

export default ChatCheckedFilledIcon;
